import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./styles/app.scss";
import "./styles/variables.scss";
import locale from "element-ui/lib/locale/lang/en";

import App from "./App.vue";
import VueAxios from "vue-axios";
import MsalPlugin from "@/core/plugins/vue.msal.plugin";
import VueMoment from "vue-moment";
import axios from "axios";

import { store } from "@/core/store";
import router from "./router";
import "./registerServiceWorker";

import { Default, Empty } from "@/layouts";
import { truncateFilter } from "./core/filters";

Vue.component("default-layout", Default);
Vue.component("empty-layout", Empty);
Vue.filter("truncate", truncateFilter);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

Vue.use(VueAxios, axios);
Vue.use(MsalPlugin, {});
Vue.use(VueProgressBar, {
  color: "#5fce58",
  failedColor: "#F56C6C",
  thickness: "2px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
});
Vue.use(ElementUI, { locale });
Vue.use(VueMoment);

const vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
